"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultShareStatus = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../../model");
var ShareStatusIndicator_1 = require("./ShareStatusIndicator");
/**
 * @alpha
 */
exports.DefaultShareStatus = function (props) {
    var arePermissionsEnabled = model_1.useDashboardSelector(model_1.selectEnableAnalyticalDashboardPermissions);
    var supportsAccessControl = model_1.useDashboardSelector(model_1.selectSupportsAccessControlCapability);
    var canManageAnalyticalDashboard = model_1.useDashboardSelector(model_1.selectCanManageAnalyticalDashboard);
    if (!arePermissionsEnabled || !supportsAccessControl || !canManageAnalyticalDashboard) {
        return null;
    }
    return react_1.default.createElement(ShareStatusIndicator_1.ShareStatusIndicator, tslib_1.__assign({}, props));
};
//# sourceMappingURL=DefaultShareStatus.js.map